export function formatNumber(value, digits = 0) {
  const num = Number(value) || 0;
  try {
    return new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    }).format(num);
  } catch {
    return num.toFixed(digits);
  }
}

export function formatPercent(value, digits = 1) {
  return `${formatNumber(value, digits)}%`;
}

export function formatSigned(value, digits = 0) {
  const num = Number(value) || 0;
  const prefix = num > 0 ? "+" : "";
  return `${prefix}${formatNumber(num, digits)}`;
}

export function formatDateTime(value) {
  if (!value) return "-";
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return String(value);
  try {
    return new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    }).format(dt);
  } catch {
    return dt.toLocaleString();
  }
}

export function formatScenarioKind(kind) {
  return kind === "official" ? "Oficial" : "Rascunho";
}
